export default __webpack_public_path__ + "static/media/1.7319ca3c.png";